import IconCar from '../../assets/svg/IconCar';
import IconCoupon from '../../assets/svg/IconCoupon';
import IconNavRight from '../../assets/svg/IconNavRight';
import { warrior } from '../../constants/color';
import FeatureFlags from '../../constants/FeatureFlags';
import { Trans } from '../../i18n';
import { makeRemoteValuesByKey } from '../../redux/selectors/VBConfigSelector';
import { useSelector } from '../../redux/utils';
import * as navigationService from '../../utils/navigationService';
import routeUtils from '../../utils/routes';
import { showNumberWithComma } from '../../utils/stringHelper';
import { useData } from './hooks/useData';
import { S } from './styles';

const handleNavigate = () => {
  navigationService.navigate('BrowseHistoryListPage');
};
const FreeDeliveryTransComponents = {
  money: <S.FreeDeliveryMoney />,
  bold: <S.BoldText />,
};

const CouponTransComponents = {
  money: <S.CouponMoney />,
};

export default function FreeDeliveryBar() {
  const { freeShippingDiff, isReachThreshold, suggestCoupon } = useData();

  const isReachCouponThreshold = suggestCoupon.diff <= 0;

  switch (true) {
    case !isReachThreshold:
      return (
        <Container>
          <FreeDeliveryThresholdComponent freeShippingDiff={freeShippingDiff} />
        </Container>
      );
    case !isReachCouponThreshold && suggestCoupon.value > 0:
      return (
        <Container isReachThreshold>
          <S.LeftSection>
            <S.CouponWrapper>
              <IconCoupon size={24} />
            </S.CouponWrapper>
            <S.Text>
              <Trans
                i18nKey="coupon-threshold-text"
                components={CouponTransComponents}
                values={{
                  couponDiff: suggestCoupon.diff,
                  couponAmount: suggestCoupon.value,
                }}
              />
            </S.Text>
          </S.LeftSection>
          <IconNavRight fillColor={warrior} size={18} />
        </Container>
      );
    default:
      return null;
  }
}

const Container = ({ children, isReachThreshold = false }) => {
  return (
    <S.Container
      accessibilityRole="link"
      href={routeUtils.compileToPath('BrowseHistoryListPage')}
      onPress={handleNavigate}
      isReachThreshold={isReachThreshold}
    >
      {children}
    </S.Container>
  );
};

const FreeDeliveryThresholdComponent = ({
  freeShippingDiff,
}: {
  freeShippingDiff?: number;
}) => {
  const remoteValue = useSelector(
    makeRemoteValuesByKey('CX_2444_cross_border_shipping_fee')
  );

  if (typeof freeShippingDiff === 'undefined') {
    return null;
  }

  return (
    <>
      <S.LeftSection>
        <IconCar />
        <S.Text>
          <Trans
            i18nKey={
              FeatureFlags.CX_2444_OVERSEA_SHIPPING_FEE && remoteValue
                ? 'tw-free-delivery-text'
                : 'free-delivery-text'
            }
            components={FreeDeliveryTransComponents}
            values={{
              money: showNumberWithComma(freeShippingDiff),
            }}
          />
        </S.Text>
      </S.LeftSection>
      <IconNavRight fillColor={warrior} size={18} />
    </>
  );
};
